import { translation } from 'I18n/i18n'
import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
export default function HSEVisiteur() {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const { setCounter, counterDefault } = useContext(CounterContext)
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)

   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(translation(lang, 'hse', 'title'))
      setAnchorButton(translation(lang, 'hse', 'anchorBtnsVisitor'))
   }, [])

   return (
      <ScrollContainer>
         <AnchorPart anchor={{ partName: translation(lang, 'hse', 'anchors')[0], id: 0 }} />
         <ScrollSection zoneName={lang === 'en' ? 'EHS policies' : 'Politiques HSE'} />
         <AnchorPart anchor={{ partName: translation(lang, 'hse', 'anchors')[1], id: 1 }} />
         <ScrollSection zoneName={lang === 'en' ? 'PPE' : 'EPI'} />
         <AnchorPart anchor={{ partName: translation(lang, 'hse', 'anchors')[2], id: 2 }} />
         <ScrollSection zoneName={lang === 'en' ? 'PASS approach' : 'PASS'} />
      </ScrollContainer>
   )
}
